import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";


interface ConfirmButtonProps {
    modal: string;
    appendToClosestSelector?: string;
}

@Dce("ConfirmButton")
export default class ConfirmButton extends DceComponent<ConfirmButtonProps> {

    private modal: HTMLElement;

    constructor(elem: DceHTMLElement, props: ConfirmButtonProps) {
        super(elem, props);

        this.modal = document.getElementById(this.props.modal);

        let closestModal;
        if(this.props.appendToClosestSelector){
            closestModal = this.elem.closest(this.props.appendToClosestSelector);
        }else {
           closestModal = this.elem.closest('.modal');
        }

        if (this.modal && closestModal) {
            closestModal.append(this.modal);
        }

        this.elem.addEventListener('click', e => {
            e.preventDefault();
            if (this.modal) {
                this.modal.classList.add("active");
            }
        });

    }

    public isVisible(elem: HTMLElement) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    }

    onRemove() {
        if (this.modal) {
            this.modal.remove();
        }
    }
}
